import { CLIENT_CONFIG } from '@/constants'
import { getPluginSlots } from '@/plugin/slots'

export type OrganisationLogoSource = {
  organisation_slug?: string | null
  organisation_name?: string | null
}

/** Tenant logo for jobs posted by the tenant's own organisation when the API omits its logo. */
export function tenantOrganisationLogoFallback(
  opportunity: OrganisationLogoSource,
  tenantLogoSrc: string | undefined,
): string | undefined {
  if (!getPluginSlots().tenantLogoFallback || !tenantLogoSrc) return undefined
  const handle = CLIENT_CONFIG.toLowerCase()
  const slugOk = opportunity.organisation_slug?.trim().toLowerCase() === handle
  const nameOk = opportunity.organisation_name?.trim().toLowerCase() === handle
  return slugOk || nameOk ? tenantLogoSrc : undefined
}
